<template>
  <div id="help-shop-follow" class="help">
    <call />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>

    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__head">
            <a
              href="#"
              class="l-main__head--control l-main__head--control--back"
            >
              <!-- <img src="images/icon/icon-back-white.svg?v=2" alt="" /> -->
            </a>
            <div class="l-main__head--title">ヘルプ</div>
            <a @click="$router.go(-1)" class="l-main__head--control l-main__head--control--close">
              <img src="/assets/images/icon/icon-close-black.svg" alt="" />
            </a>
          </div>
          <div class="l-main__body">
            <div class="l-check-cart">
              <div class="l-check-cart__head">
                <div class="l-check-cart__title text-left">ショップのフォロー</div>
                <p>ショップをフォローすると、TOPページにフォローショップが表示されます。</p>
                <div class="help-card">
                  <div class="l-check-cart__title text-left">ショップを探す</div>
                  <p class="l-check-cart__title text-left">1.ショップアイコンをタップ</p>
                  <p>下部ナビゲーションの「ショップ」をタップします。</p>
                  <img class="help-m-b-40" src="/assets/images/help-shopfollow-1.png?t=20220520" alt="" />
                  <p class="l-check-cart__title text-left">2.カテゴリーをタップ</p>
                  <p>対象のショップが入っているカテゴリーをタップすると、ショップが表示されます。</p>
                  <img class="" src="/assets/images/help-shopfollow-2.png" alt="" />
                </div>
                <div class="help-card">
                  <div class="l-check-cart__title text-left">ショップをフォローする</div>
                  <p class="l-check-cart__title text-left">1.フォローするボタンをタップ</p>
                  <p>各ショップのフォローするボタンをタップすると、フォローできます。</p>
                  <img class="" src="/assets/images/help-shopfollow-3.png" alt="" />
                  <img class="" src="/assets/images/help-shopfollow-4.png" alt="" />
                </div>
                <div class="help-card">
                  <div class="l-check-cart__title text-left">フォローショップの確認</div>
                  <p class="l-check-cart__title text-left">1.TOPにフォローショップが表示される</p>
                  <p>フォローすると、TOPにフォローしたショップが表示されるようになります。</p>
                  <img class="" src="/assets/images/help-shopfollow-5.png" alt="" />
                </div>
                <div class="help-card">
                  <div class="l-check-cart__title text-left">ショップのフォローを解除する</div>
                  <p class="l-check-cart__title text-left">1.フォロー中ボタンをタップ</p>
                  <p>フォローショップの「フォロー中」ボタンをタップすると、フォローを解除する事ができます。</p>
                  <img class="" src="/assets/images/help-shopfollow-6.png" alt="" />
                  <img class="" src="/assets/images/help-shopfollow-7.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div v-on:click="backPagePrevious" class="c-btn-check l-shop-deal__box-back box-center">
            <div class="l-shop-deal__box-back--icon"><img src="/assets/images/icon/icon-back.svg" alt=""></div>
            <div class="l-shop-deal__box-back--title">戻る</div>
            <div class="l-shop-deal__box-back--icon"></div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import MenuApp from "../components/Menu.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";

export default Vue.extend({
  name: "HelpShopFollow",
  components: {
    "header-app": Header,
    "menu-app": MenuApp,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>